// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.api.web.external.properties.analytics.CustomerAnalyticsInsightsCompMetricType

export enum CustomerAnalyticsInsightsCompMetricType {
  CONTACT_RATE = 'CONTACT_RATE',
  IMPRESSION = 'IMPRESSION',
  LEADS = 'LEADS',
  VIEWS = 'VIEWS',
}

export const CustomerAnalyticsInsightsCompMetricType_values = [
  CustomerAnalyticsInsightsCompMetricType.CONTACT_RATE,
  CustomerAnalyticsInsightsCompMetricType.IMPRESSION,
  CustomerAnalyticsInsightsCompMetricType.LEADS,
  CustomerAnalyticsInsightsCompMetricType.VIEWS,
] as const;
